<template>
    <validation-observer ref="signatureService">
        <div>
        <div class="form-group p-0-14">
            <div class="signature-attribute">
                <validation-provider :rules="attribute.mandatory ? 'required' : ''" v-slot="{errors}">
                <label class="attribute-label">{{ attribute.attribute_name }}</label>

                <div :id="accordionId" ref="accordion" role="tablist" aria-multiselectable="true">
<!--                    <div class="card">-->
<!--                        <div class="card-header" role="tab" id="section1HeaderId">-->
<!--                            <div class="btn-group" role="group">-->
<!--                                <button type="button" class="btn-new-primary btn" data-toggle="collapse" data-parent="#accordianId" :href="`#${sectionId}`"-->
<!--                                        aria-expanded="false" aria-controls="section1ContentId">-->
<!--                                    {{ attribute.attribute_name }}-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div :id="sectionId" class="collapse" role="tabpanel" aria-labelledby="section1HeaderId">-->
<!--                            <div class="card-body">-->
<!--                                <div class="canvas-control">-->
<!--                                    <canvas ref="canvas" class="signature-canvas" @click="removePlaceholder"></canvas>-->
<!--                                </div>-->
<!--                                <div class="btn-toolbar" role="toolbar">-->
<!--                                    <div class="btn-group" role="group">-->
<!--                                        <button type="button" class="btn btn-primary" @click="updateSignature">Update-->
<!--                                            Signature-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                    <div class="btn-group" role="group">-->
<!--                                        <button type="button" class="btn btn-default" @click="clearSignature">Clear-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->



                        <img :src="attribute.service_attribute_value" width="140px" class="image-bigpic">

                        <div class="card">
                          <div class="card-header" role="tab" id="section1HeaderId">
                            <div class="btn-group" role="group">
                              <button type="button" class="collapseButton btn-new-primary btn" data-toggle="collapse" data-parent="#accordianId" :href="`#${sectionId}`"
                                      aria-expanded="false" aria-controls="section1ContentId">
                                {{ attribute.attribute_name }}
                              </button>
                            </div>
                          </div>
                          <div :id="sectionId" class="collapseDiv collapse" role="tabpanel" aria-labelledby="section1HeaderId">
                            <div class="card-body">
                              <div class="row">
                                <div :class="{'col-md-12 col-md-offset-4' : true , 'm-top-10 m-bottom-10 col-md-offset-0 sign-canvas':isInquiry} ">
                                  <input  v-if = "url" :id="id" type="hidden" :name="name" :value="url" >
                                  <input  v-else :id="id" type="hidden" :name="name" :value="replacedText" >
                                  <canvas
                                      ref="canvas"
                                      class="signature-canvas width_border_border-radius "
                                      @click="removePlaceholder">
                                    <img :src="attribute.service_attribute_value">
                                  </canvas>

                                </div>
                                <div class="col-md-12 text-center" v-if="captured">
                                  <div class="alert alert-success"> captured successfully </div>
                                </div>
                              </div>
                              <div class="btn-toolbar" role="toolbar" v-if="isLoading"><img src="/pic/loading-4.gif"></div>
                              <div class="btn-toolbar" role="toolbar" v-else>
                                <div class="btn-group" role="group">
                                  <button type="button" class="btn btn-primary" @click="updateSignature">Update
                                    Signature
                                  </button>
                                </div>
                                <div class="btn-group" role="group">
                                  <button type="button" class="btn btn-default" @click="clearSignature">Clear
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                        </div>






                </div>
<!--                    <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>-->
                </validation-provider>
            </div>
        </div>
        </div>
    </validation-observer>
</template>

<script>

import {uploadSignature} from "@/modules/Services/api/attributes/types"
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import Api from "../../../../Forms/api";
import {updateFormQuestionOnViewInquiry} from "../../../../../events/sharedMethods";

export default {
    name: "SignatureAttribute",
    props: {
        attribute: {
            type: Object,
            required: true
        },
        clone: 0,
        isPopUp:false,
        dataSubmit: {
          type: Object,
          default() {
            return {}
          }
        },
        s3Path:{

          default() {
            return '';
          }
        },
        viewPage:false,
      isInquiry:true,

    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            image: null,
            canvas: null,
            context: null,
            customerId: null,
            captured: false,
            url: null,
            isLoading: false,
            replacementText: null,


        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }
            
            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get accordion Id
         * @returns {string}
         */
        accordionId() {
            return `accordion_attribute_${this.attribute.attribute_id}`
        },
        sectionId() {
            return `section_${this.id}`
        },





      replacedText() {
        // Use the replace method with a regular expression to replace the substring
        // if(this.question.answer_text){
        //   let link  = this.question.answer_text.replace(
        //       this.s3Path+this.s3Path,
        //       this.s3Path
        //   );
        //   this.question.value = link;
        //   return link;
        // }
      },
    },
    methods: {
        addEventListeners() {


            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.signatureService.validate();
                if(!validated)
                {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService',this.attribute)

                }
                verify(validated)
            })


        },
        setCanvasWidth() {
            // this.canvas = this.$refs['canvas'];
            // this.context = this.canvas.getContext("2d")
            // this.context.canvas.width = this.$refs['accordion'].offsetWidth

          this.canvas = this.$refs['canvas'];
          if(this.canvas){
            this.context = this.canvas.getContext("2d");
            new SignaturePad(this.canvas);
          }



        },
        removePlaceholder() {
            // this.canvas.classList.remove('signature-canvas')
        },
        updateSignature() {
            this.image = this.canvas.toDataURL("image/png", 1.0);
            this.$emit('input', this.image)
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribute,
                value: this.image
            })



          uploadSignature({
            image: this.image,
            customer_id: 2,
            attribute_id: this.attribute.attribute_id

          }).then(response => {
            if (response.data.status == "success"){
              this.captured = true;
              this.url = response.data.result;
              this.attribute.service_attribute_value = response.data.result;
              this.isLoading = false;

              // if(this.viewPage && this.isInquiry){
              //   updateFormQuestionOnViewInquiry( response.data.result, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
              // }
            }
          })

            // uploadSignature({
            //     image: this.image,
            //     customer_id: 123123,
            //     attribute_id: this.attribute.attribute_id
            // }).then(response => {
            //
            // })







          // this.resetSignature();
          //
          // this.image = this.canvas.toDataURL("image/png", 1.0);
          // // alert(this.image )
          // // alert( this.question.update_booking_question_id);
          // // Api.uploadSignature({
          // //   image: this.image,
          // //   customer_id: 2,
          // //   attribute_id: this.question.update_booking_question_id,
          // // }).then(response => {
          // //   if (response.data.status == "success"){
          // //     this.captured = true;
          // //     this.url = response.data.result;
          // //     this.question.value = response.data.result;
          // //     this.dataSubmit[`question_${this.question.update_booking_question_id}_0`] = this.url;
          // //     this.isLoading = false;
          // //
          // //     if(this.viewPage && this.isInquiry){
          // //       updateFormQuestionOnViewInquiry( response.data.result, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
          // //     }
          // //   }
          // // })





        },
        clearSignature() {
            // noinspection JSUnresolvedFunction
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.canvas.classList.add('signature-canvas')
            this.image = null;
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribute,
                value: this.image
            })
        },
        listenToCustomerChange() {
            EventBus.$on('onCustomerChanged', (customer) => {
                this.customerId = customer.customer_id
            })
        }
    },
    created() {
        this.listenToCustomerChange()
    },
    mounted() {
        this.setCanvasWidth();
        this.addEventListeners()
    }
}
</script>

<style scoped>
.canvas-control {
    width: 100%;
    min-height: 300px;
}

.signature-canvas {
    background-image: url(/pic/sign-here.png);
    background-repeat: no-repeat;
    background-position: center;
}
</style>